"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatPrice = formatPrice;
const legacy_enums_1 = require("@daytrip/legacy-enums");
function formatPrice(price, currency, options, locale) {
    const formatter = new Intl.NumberFormat(locale || undefined, {
        style: "currency",
        currency: typeof currency === "string" ? currency : legacy_enums_1.CurrencyEnumCurrencyIso[currency],
        maximumFractionDigits: 0,
        ...options,
    });
    return formatter.format(price);
}
//# sourceMappingURL=formatPrice.js.map